export default __webpack_public_path__ + "static/media/proceso-trabajo.67a74577.webp";